import classnames from 'classnames';
import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useNodeSize from '../../../hooks/useNodeSize';
import { Context as StoreContext } from '../../../providers/store';

import './styles.less';

const HeaderBanner = ({ children, className, bannerId }) => {
  const storageKey = `dismissed${bannerId}`;
  const [dismissed, setDismissed] = useState(false);
  const containerRef = useRef(null);
  const { dispatch } = useContext(StoreContext);

  useEffect(() => {
    setDismissed(!!sessionStorage.getItem(storageKey));
  }, [storageKey]);

  useNodeSize(containerRef, size => {
    dispatch({ type: 'RESIZE_BANNER', size });
  });

  const dismiss = () => {
    setDismissed(true);
    sessionStorage.setItem(storageKey, true);
    dispatch({
      type: 'RESIZE_BANNER',
      size: {
        offsetWidth: 0,
        offsetHeight: 0,
        clientWidth: 0,
        clientHeight: 0,
      },
    });
  };

  if (dismissed) return null;

  const classes = classnames('header-banner', className);

  return (
    <div ref={containerRef} className={classes}>
      <div>{children}</div>
      <i className="header-banner__close" onClick={dismiss} />
    </div>
  );
};

HeaderBanner.propTypes = {
  bannerId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

HeaderBanner.defaultProps = {
  className: '',
};

export default HeaderBanner;
